import { TranslationContext } from 'contexts/translation-context';
import { useContext } from 'react';
import styled from 'styled-components';
import { BlueLink } from 'components/common/link';
import { errorListTypes } from 'constants/error-list';

const Container = styled.div`
  padding: 0 20px 45px 20px;
`;
const Title = styled.div`
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
  margin-top: 40px;
  font-family: ${props => props.theme.fonts.montserratMedium};
  color: ${props => props.theme.colors.black};
`;
const ContentMessage = styled.div`
  font-size: 14px;
  text-align: center;
  font-family: ${props => props.theme.fonts.montserratLight};
  white-space: break-spaces;
  padding-bottom: 12px;
  color: ${props => props.theme.colors.black};
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratLight};
  font-size: 14px;
`;

// translation keys per error: [title, details, text before and after the "contact us" link]
const MESSAGES: { [errorType: string]: [string, string, string, string] } = {
  [errorListTypes.hasSubscriptionFound]: [
    'membership_request_already_in_progress',
    'membership_request_already_in_progress_details',
    'please',
    'and_we_will_help_you_finish_it'
  ],
  [errorListTypes.companyAlreadyExists]: [
    'company_already_registered',
    'company_already_registered_details',
    'please_check_the_details_or',
    'for_help'
  ],
  [errorListTypes.emailLinkedToExistingAccount]: [
    'email_already_registered',
    'email_already_registered_details',
    'please',
    'and_we_will_set_up_your_access'
  ]
};
const DEFAULT_MESSAGE: [string, string, string, string] = [
  'something_went_wrong',
  'we_could_not_complete_your_registration_details',
  'please',
  'and_we_will_sort_it_out'
];

type Props = {
  errorType?: string;
};

const ConfirmAndCheckoutNotSuccessModal = ({ errorType }: Props) => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const [title, details, beforeLink, afterLink] = MESSAGES[errorType ?? ''] ?? DEFAULT_MESSAGE;

  return (
    <Container>
      <Title>{TRANSLATION_TEXT[title]}</Title>
      <ContentMessage>{TRANSLATION_TEXT[details]}</ContentMessage>
      <ContentMessage>
        {TRANSLATION_TEXT[beforeLink]}
        <StyledLink to={'https://www.rapnet.com/contact/support/'} external newTab>
          {TRANSLATION_TEXT.contact_us_lower}
        </StyledLink>
        {TRANSLATION_TEXT[afterLink]}
      </ContentMessage>
    </Container>
  );
};

export default ConfirmAndCheckoutNotSuccessModal;
